export const getTypeTransaction = state => state.transaction;
